import { useTranslations } from '@/hooks/useTranslations'

export type SidebarItem = {
  id: string
  label: Parameters<ReturnType<typeof useTranslations<'sidebar'>>>[0]
  icon: string
  activePaths: string[]
  href: string
}

export type NavigationSidebarItem = SidebarItem & {
  children?: SidebarItem[]
}

export type NavigationSidebarSection = {
  id: string
  hideLabel?: boolean
  label?: Parameters<ReturnType<typeof useTranslations<'sidebar'>>>[0]
  items: NavigationSidebarItem[]
}

export const AdminNavigationSidebarItems: NavigationSidebarSection[] = [
  {
    id: 'admin_management',
    items: [
      {
        id: 'admin_dashboard',
        label: 'admin_dashboard',
        icon: 'dashicons:admin-home',
        href: '/admin',
        activePaths: ['^/admin$'],
      },
      {
        id: 'admin_company',
        label: 'admin_company',
        icon: 'mdi:office-building',
        href: '/admin/company-profile',
        activePaths: ['^/admin/company-profile'],
      },
      {
        id: 'admin_settings',
        label: 'admin_settings',
        icon: 'mdi:cog-outline',
        href: '/admin/settings',
        activePaths: ['^/admin/settings'],
      },
      {
        id: 'admin_picklist',
        label: 'admin_picklist_management',
        icon: 'mdi:format-list-bulleted-type',
        href: '/admin/picklist',
        activePaths: ['^/admin/picklist'],
      },
      {
        id: 'admin_user',
        label: 'admin_employee_management',
        icon: 'mdi:user',
        href: '/admin/user',
        activePaths: ['^/admin/user'],
      },
      {
        id: 'admin_role',
        label: 'admin_role_management',
        icon: 'eos-icons:cluster-role',
        href: '/admin/role',
        activePaths: ['^/admin/role'],
      },
      {
        id: 'admin_expenses',
        label: 'admin_expenses',
        icon: 'mdi:cash-minus',
        href: '/admin/expense',
        activePaths: ['^/admin/expense'],
      },
      {
        id: 'admin_temp_workers',
        label: 'admin_temp_workers',
        icon: 'mdi:account-clock',
        href: '/admin/temp-workers',
        activePaths: ['^/admin/temp-workers'],
      },
      {
        id: 'admin_bill',
        label: 'admin_bill_management',
        icon: 'lucide:receipt',
        href: '/admin/bill',
        activePaths: ['^/admin/bill'],
      },
      {
        id: 'admin_outstanding',
        label: 'admin_outstanding_management',
        icon: 'ic:round-money-off',
        href: '/admin/outstanding',
        activePaths: ['^/admin/outstanding'],
      },
      // {
      //   id: 'admin_customer',
      //   label: 'admin_customer_management',
      //   icon: 'ix:customer-filled',
      //   href: '/admin/customer',
      //   activePaths: ['^/admin/customer'],
      // },
    ],
  },
]
